angular.module('picmonicng').factory('UserTiles', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/user/tiles/:user_tile_id',
      { user_tile_id: '@user_tile_id' },
      {
        update: { method: 'PUT', isArray: false },
        post: { method: 'POST', isArray: false },
        delete: { method: 'DELETE', isArray: true },
      }
    );
  },
]);
